import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  constructor(private http: HttpClient) { }

  UpdatePlanManagement(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/mgt/update`, params);
  }

  ReadPlanManagement(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/mgt/read`, params);
  }

  UpdatePlanSetting(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/update`, params);
  }

  ReadPlanSetting(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/read`, params);
  }

  AddPlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/add`, params);
  }

  UpdatePlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/update`, params);
  }

  DeletePlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/delete`, params);
  }

  ConfirmPlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/confirm`, params);
  }

  SendPlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/send`, params);
  }

  ActivatePlanKey(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/key/activate`, params);
  }

  ReadPlanInfoList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/list/read`, params);
  }

  ReadPriceList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/plan/price/read`, params);
  }
}

